export default __webpack_public_path__ + "static/media/sideNavClose.87eb9ef6.svg";